import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  Chip,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router";
import axios from "axios";
import { authenticationService } from "src/services";
import { deleteEntry, get } from 'src/services/httpClient.service';

const Role = () => {

  const API_URL = process.env.REACT_APP_BASE_API_URL;

  const navigate = useNavigate();
  const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();
  const [searchTerm, setSearchTerm] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [rolesList, setRolesList] = useState([]);

  console.log(vendorId,'',franchiseId)
  const getRolesList = async()=>{
    const data = await get(`${API_URL}/api/globalRole/vendor/${vendorId}/franchise/${franchiseId}/findAll`)
    console.log('data',data?.data)
    setRolesList(data?.data);
  }

  useEffect(()=>{
    getRolesList()
  },[])

  // const rows = [
  //   { id: 1, name: "Admin", createdOn: "20/Jun/2014", status: "Approved" },
  //   { id: 2, name: "Bangalore DISTRIBUTORS", createdOn: "02/Jan/2021", status: "Approved" },
  //   { id: 3, name: "COLLECTION PERSON", createdOn: "13/May/2017", status: "Approved" },
  //   { id: 4, name: "DISTRIBUTORS", createdOn: "17/Sep/2016", status: "Approved" },
  //   { id: 5, name: "LCO", createdOn: "17/Sep/2016", status: "Approved" },
  //   { id: 6, name: "SERVICE PERSON", createdOn: "22/Oct/2017", status: "Approved" },
  // ];

  const filteredRows = rolesList && rolesList.filter((r) =>
    r?.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

const handleDeleteClick = (role) => {
  setSelectedRole(role);
  setOpenDialog(true);
};

const handleConfirmDelete = async () => {
  if (!selectedRole) return;
  
  try {
      // deleteEntry returns resp.data, not the full response
      const result = await deleteEntry(`${API_URL}/api/globalRole?globalRoleId=${selectedRole.id}`);
      
      // Check if result exists (meaning successful)
      if (result) {
          // Refresh the roles list after successful deletion
          await getRolesList();
          console.log("Role deleted successfully");
      }
  } catch (error) {
      console.error("Error deleting role:", error);
      alert("Failed to delete role: " + (error.response?.data?.message || error.message));
  } finally {
      setOpenDialog(false);
      setSelectedRole(null);
  }
};


  const handleCancelDelete = () => {
    setOpenDialog(false);
    setSelectedRole(null);
  };



  
  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    { field: "createdDate", headerName: "Created On", flex: 1 },
    {
      field: "isActive",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        const isActive = params.value === true || params.value === 1;

        return (
          <Chip
            label={isActive ? "Active" : "Inactive"}
            color={isActive ? "success" : "error"}
            sx={{
              fontWeight: "bold",
              backgroundColor: isActive ? "#00C853" : "#D32F2F",
              color: "#fff",
            }}
          />
        );
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          startIcon={<EditIcon />}
          sx={{ backgroundColor: "#8C7CF0", color: "white" }}
          onClick={() => navigate(`/Role/updaterole/${params.row.id}`)}
        >
          Edit
        </Button>
      ),
    },
    {
      field: "menus",
      headerName: "Menus",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          startIcon={<MenuIcon />}
          sx={{ backgroundColor: "#8C7CF0", color: "white" }}
          onClick={() => navigate(`/Role/menusrole/${params.row.id}`)}
        >
          Menus
        </Button>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          sx={{ backgroundColor: "red", color: "white" }}
          size="small"
          startIcon={<DeleteIcon />}
          onClick={() => handleDeleteClick(params.row)}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          p: 2,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          ⚙️ Manage Role
        </Typography>

        <Button variant="contained" onClick={() => navigate("/Role/addrole")}>
          + Add
        </Button>
      </Box>

      {/* Search */}
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
        <TextField
          size="small"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Stack>

      {/* Table */}
      <Box sx={{ height: 420, borderRadius: 1 }}>
        <DataGrid
          rows={filteredRows || []}
          columns={columns || []}
          pageSize={10}
          rowsPerPageOptions={[5, 10, 20, 50]}
          pagination
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              fontWeight: "bold",
            },
          }}
        />
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete{" "}
            <strong>{selectedRole?.name}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            sx={{ backgroundColor: "red", color: "#fff" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Role;
